import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, Eye, EyeOff } from "lucide-react";
import "../styles/UserLogin.css";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleResetPassword = async () => {
    if (!password || !confirmPassword) {
      return alert("Please fill out both fields.");
    }

    if (password !== confirmPassword) {
      return alert("Passwords do not match.");
    }

    try {
      const res = await axios.post(
        "https://tn.server.goatteachers.com/api/auth/reset-password",
        {
          token,
          password,
        },
      );

      alert(" Password reset successfully!");
      navigate("/login"); // Or home page
    } catch (err) {
      console.error(err);
      alert("❌ Error resetting password. Link may have expired.");
    }
  };

  return (
    <div className="page-container bg-blue">
      <div className="card">
        <div className="card-header">
          <Lock className="icon-lg text-blue" />
          <h2>Reset Password</h2>
          <p>Enter a new password below.</p>
        </div>

        <div className="form">
          <div className="input-wrapper">
            <Lock className="input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="toggle-icon"
            >
              {showPassword ? (
                <EyeOff className="icon-sm" />
              ) : (
                <Eye className="icon-sm" />
              )}
            </button>
          </div>

          <div className="input-wrapper">
            <Lock className="input-icon" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>

          <button onClick={handleResetPassword} className="btn btn-student">
            Reset Password
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
